/// <reference path="../../typedefs.js" />
import React from 'react';
import axios from 'axios';
import Config from '../shared/Config';
import { handlerApiError } from '../shared/errorHandler';

const { apiBaseUrl } = Config();
const endpointUrl = `${apiBaseUrl}/api/service`;
const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export default function useCreateService() {
  const access_token = window.sessionStorage.getItem('token');
  headers.Authorization = `Bearer ${access_token}`;
  const [response, setResponse] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  /** @param {Service} json */
  const sendCreateService = async (json) => {
    setLoading(true);
    setResponse({});
    const config = {
      url: endpointUrl,
      headers,
      method: 'post',
      data: json,
    };
    axios(config)
      .then((resp) => {
        // Normalize successful response
        setResponse({
          success: true,
          data: resp.data,
        });
      })
      .catch((err) => {
        handlerApiError(err);
        // Normalize error response
        const statusCode = err.response?.status;
        let errorMessage = 'An unexpected error occurred';

        if (err.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err.response?.data?.error) {
          errorMessage = err.response.data.error;
        } else if (statusCode === 401) {
          errorMessage = 'You are not authenticated. Please log in again.';
        } else if (statusCode === 403) {
          errorMessage = 'You are not authorized to add services to this team.';
        } else if (statusCode === 500) {
          errorMessage = 'A server error occurred. Please try again later.';
        } else if (err.message) {
          errorMessage = err.message;
        }

        setResponse({
          success: false,
          data: {
            success: false,
            message: errorMessage,
            statusCode: statusCode,
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { response, loading, sendCreateService };
}
